import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { CardOverlay } from './CardOverlay';
import { PlayIcon } from './PlayIcon';

const style = StyleSheet.create({
  videoCoverWrap: {
    position: 'relative',
    display: 'flex',
  },
});


export const VideoCoverWrapper: React.FunctionComponent = ({ children }) => (
  <div className={css(style.videoCoverWrap)}>
    {children}
    <PlayIcon />
  </div>
);

interface ConditionalVideoWrapProps {
  shouldWarp: boolean
}

export const ConditionalVideoWrap: React.FunctionComponent<ConditionalVideoWrapProps> = ({ shouldWarp, children }) => (shouldWarp ? <VideoCoverWrapper>{children}</VideoCoverWrapper> : <React.Fragment>{children}</React.Fragment>);
